import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { RedirectLoginOptions } from '@auth0/auth0-spa-js';
import { catchError, of, switchMap, tap } from 'rxjs';
import { firstValueFrom } from 'rxjs';

const VDO_ACCOUNT = '@vdo_desired_account';

// const parseJwt = token => {
//   try {
//     return JSON.parse(atob(token.split('.')[1]));
//   } catch (e) {
//     return null;
//   }
// };

@Injectable({
  providedIn: 'root'
})
export class AuthMapService {
  private storage = localStorage;

  constructor(private auth0: AuthService) {}

  checkAuth(): Promise<any> {
    return this.checkAuthWithParam();
  }

  checkAuthWithParam(): Promise<any> {
    const urlParams = new URLSearchParams(window.location.search);
    let vdoAccountParam = urlParams.get('vdoAccount');
    const query = window.location.search;
    const isAuth0Redirect = query.includes('code=') && query.includes('state=');
    const isAuth0Error = query.includes('error=login_required');

    let redirectUrl = window.location.origin;
    if (vdoAccountParam) {
      redirectUrl += '?vdoAccount=' + vdoAccountParam;
      this.setDesiredVdoAccount(vdoAccountParam);
    } else {
      vdoAccountParam = this.getDesiredVdoAccount();
    }

    // don't know why this happens but it does when we have two tabs, one on vdo and one on maps
    // and we logout from vdo and refresh maps page
    if (isAuth0Error) {
      // this.auth0.loginWithRedirect({ prompt: 'login', redirect_uri: redirectUrl });
      this.auth0.logout({ returnTo: redirectUrl });
    }

    // always redirect to auth0 when starting app
    // getAccessTokenSilently should be enough to handle multi account users and change account in token
    // but it does not work if auth0 session is already active but user changed on Vdo portal
    // user loggs in on TM with user1, user goes to maps, user goes to TM, logs out, logs in with user2 and goes to maps
    // getAccessTokenSilently will fetch token for user1
    return firstValueFrom(
      this.auth0.isAuthenticated$.pipe(
        switchMap(loggedIn => {
          if (!isAuth0Redirect) {
            try {
              const params: RedirectLoginOptions = { prompt: 'none', redirect_uri: redirectUrl };
              if (vdoAccountParam) {
                params['vdo_account'] = vdoAccountParam;
              }
              this.auth0.loginWithRedirect(params);
              return of('');
            } catch (e) {
              console.log(e.error);
              this.handleAuthError(e);
              return e.error;
            }
          }
          return of('');

          // if (!vdoAccountParam || vdoAccountParam === actualVdoAccount) {
          //   console.log('auth0 token checkAuthWithParam logged in');
          //   return of('');
          // }
          // // for multi account user, we need a token with account id from query string
          // return this.auth0.getAccessTokenSilently({ vdo_account: vdoAccountParam, ignoreCache: true }).pipe(
          //   tap(token => {
          //     console.log('auth0 token checkAuthWithParam getAccessTokenSilently');
          //     // console.log(token);
          //     let parsedToken = parseJwt(token);
          //     console.log(parsedToken);
          //     this.setDesiredVdoAccount(vdoAccountParam);
          //     // console.log(parsedToken['vdo/account'])
          //     // if(!parsedToken['vdo/account']){
          //     //   this.auth0.loginWithRedirect({ prompt: 'none', vdo_account:"789" });
          //     // }
          //   }),
          //   catchError(e => {
          //     console.log(e.error);
          //     this.handleAuthError(e);
          //     return e.error;
          //   })
          // );
        })
      )
    );
  }

  handleAuthError(e) {
    //if we cannot get an access token, it's probably that the user did not give enough consent or that it needs to login again
    if (e.error && e.error == 'consent_required') {
      console.warn(`need to get user consent`);
      this.auth0.loginWithRedirect({ prompt: 'consent' });
    }
    //sometime 3rdparty cookie blocker prevents the silent refresh. We need to login explicitly
    if (e.error && e.error == 'login_required') {
      console.warn(`need to explicitly login`);
      this.auth0.loginWithRedirect({ prompt: 'login' });
    }
  }

  private getDesiredVdoAccount() {
    return this.storage.getItem(VDO_ACCOUNT) ?? undefined;
  }

  private setDesiredVdoAccount(accountId: number | string | undefined) {
    if (accountId || accountId === 0) {
      return this.storage.setItem(VDO_ACCOUNT, `${accountId}`);
    } else {
      this.storage.removeItem(VDO_ACCOUNT);
    }
  }

  // checkAuthWithParam2(): Promise<any> {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const vdoAccountParam = urlParams.get('vdoAccount');

  //   return firstValueFrom(
  //     this.auth0.isAuthenticated$.pipe(
  //       tap(loggedIn => {
  //         if (!loggedIn) {
  //           try {
  //             this.auth0.loginWithRedirect({ prompt: 'none', vdo_account: vdoAccountParam });
  //           } catch (e) {
  //             this.handleAuthError(e);
  //           }
  //         }
  //       }),
  //       switchMap(res => {
  //         return this.auth0.getAccessTokenSilently().pipe(
  //           tap(token => {
  //             console.log('auth0 token checkAuthWithParam');
  //             console.log(token);
  //           })
  //         );
  //       })
  //     )
  //   );
  //  }
}
